import React from 'react'
import { ChevronDown } from 'lucide-react'

const SearchSelect = ({
  disabled = false,
  name,
  options = [],
  value,
  onChange,
  placeholder = 'Selecione...',
  allText = 'Todos',
  required
}) => {
  return (
    <div className="flex flex-col gap-1 relative w-full">
      <div className="relative">
        <select
          id={name}
          name={name}
          value={value}
          disabled={disabled}
          required={required}
          onChange={onChange}
          placeholder={placeholder}
          className={`appearance-none w-full border border-blueSoft rounded-xl px-3 py-2 text-base bg-white pr-10
                      ${value === '' ? 'text-blueSteel' : 'text-blueMedium'}`}
        >
          <option value="" disabled hidden>
            {placeholder}
          </option>
          <option value="" className={'text-blueMedium'}>{allText}</option>

          {options.map((opt, i) => (
            <option key={i} value={opt.value || opt} className="text-blueMedium">
              {opt.label || opt}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
          <ChevronDown size={20} className="text-tealMedium" strokeWidth={1.5} />
        </div>
      </div>
    </div>
  )
}

export default SearchSelect
